import { 
  //RECEIVE_JOURNEYS_FAILED,
  SET_JOURNEY_NAV_STEP,
  SET_SELECTED_JOURNEY,
  SET_JOURNEY_STEP,
  SET_PERSONALIZED_NAME,
  REQUEST_JOURNEY_PDF,
  SET_JOURNEY_PDF_URL,
  JOURNEY_PDF_FAILED,
  JOURNEY_PRINT_FAILED,
  REQUEST_JOURNEY_PRINT,
  SET_JOURNEY_SELECT_MODAL,
} from '../constants/journey-constants'

import {
  SET_SELECTED_ARTWORK,
  RESET_SELECTED_ARTWORK,
  SET_ARTWORK_FOR_MODAL,
  //REQUEST_JOURNEYS
} from '../constants/artwork-constants'

import { 
   TOGGLE_SELECT_JOURNEY,
   TIMER_TICK, 
   RESET_INACTIVITY_TIMER, 
   TOGGLE_IDLE_WARNING
} from '../constants/util-constants'

import Immutable from 'immutable'
import moment from 'moment'

const RESET_TO_HOME_MINUTES = 2

let localState = {
   currentNavStep: 0, // overall progress (top nav bar)
   currentJourneyStepProgress: 0, // step progress (bottom nav bar)
   selectedJourney: null, // current journey theme
   selectedJourneyArtwork:  [], // 5 pieces of art 
   selectedJourneyArtOrdered: [], // selections, after wayfinding order
   personalizedName: '', // name of the person making the journey
   pdfFile: {
      isFetching: false, // we are waiting for server response
      isPrinting: false, // we are waiting for print server response
      urlError: false, // did we encounter an error?
      printError: false, // error encountered during printing
      url: null,  // where to grab this user's pdf file after successful generation
   },
   uiState: {
      //showSelectJourney: false, // modal for choosing journey
      selectedArtworkForModal: null, // internal state for selected artwork
      showAdultOnly: false, // true/false for child/adult filtering
      selectedJourneyForModal: null, // internal state for journey selection
   },
   inactive: {
      showIdleWarning: false, // show the "Are You Still There?" dialog
      lastClick: moment.now(), // last time clicked 
   }
};

const initialState = Immutable.fromJS({
 'bottom': Object.assign({}, localState),
 'top': Object.assign({}, localState),
})


export default (state = initialState, action) => {
   let newState
   let journeyState
   const galleryId = action.payload === undefined ? null : action.payload.galleryId
   if (galleryId !== undefined) {
      journeyState = state.getIn([galleryId])
   }
   switch (action.type) {
      case SET_JOURNEY_NAV_STEP:
         newState = journeyState.withMutations( o => o.set('currentNavStep', action.payload.navStep))
         return state.setIn([galleryId], newState)
      case SET_SELECTED_JOURNEY:
         newState = journeyState.withMutations( o => o.set('selectedJourney', action.payload.journeyId))
         return state.setIn([galleryId], newState)
      case SET_JOURNEY_SELECT_MODAL:
         return state.setIn([galleryId, 'uiState', 'selectedJourneyForModal'], action.payload.journeyId)
      case SET_SELECTED_ARTWORK:
         newState = journeyState.get('selectedJourneyArtwork').set(action.payload.journeyStep, action.payload.artworkId)
         return state.setIn([galleryId, 'selectedJourneyArtwork'], newState)
      case RESET_SELECTED_ARTWORK:         
         newState = journeyState.get('selectedJourneyArtwork').clear()
         return state.setIn([galleryId, 'selectedJourneyArtwork'], newState)
      case SET_JOURNEY_STEP:
         newState = journeyState.withMutations( o => o.set('currentJourneyStepProgress', action.payload.journeyStep))
         return state.setIn([galleryId], newState)
      case TOGGLE_SELECT_JOURNEY:
         //const toggleState = (action.payload.showSelectJourney !== null ? action.payload.showSelectJourney : !journeyState.get('showSelectJourney'))
         const showAdultOnly = (action.payload.showAdultOnly ? action.payload.showAdultOnly : false)
         return state
            //.setIn([galleryId, 'uiState', 'showSelectJourney'], toggleState)
            .setIn([galleryId, 'uiState', 'showAdultOnly'], showAdultOnly)
      case SET_ARTWORK_FOR_MODAL:
         const artworkId = (action.payload.artworkId ? action.payload.artworkId : null)
         return state
            //.setIn([galleryId, 'uiState', 'showSelectJourney'], toggleState)
            .setIn([galleryId, 'uiState', 'selectedArtworkForModal'], artworkId)
      case SET_PERSONALIZED_NAME:
         return state.setIn([galleryId, 'personalizedName'], action.payload.personalizedName)
      case SET_JOURNEY_PDF_URL:
         return state.setIn([galleryId, 'pdfFile', 'url'], action.payload.pdfUrl)
                .setIn([galleryId, 'pdfFile', 'isFetching'], false)
                .setIn([galleryId, 'pdfFile', 'urlError'], false)
                .setIn([galleryId, 'pdfFile', 'printError'], false)
                .setIn([galleryId, 'pdfFile', 'isPrinting'], false)
      case REQUEST_JOURNEY_PDF:
         return state.setIn([galleryId, 'pdfFile', 'isFetching'], true)
               .setIn([galleryId, 'pdfFile', 'urlError'], false)
      case REQUEST_JOURNEY_PRINT:
         return state.setIn([galleryId, 'pdfFile', 'isPrinting'], true)
               .setIn([galleryId, 'pdfFile', 'printError'], false)
      case JOURNEY_PDF_FAILED:
         return state.setIn([galleryId, 'pdfFile', 'isFetching'], false)
                .setIn([galleryId, 'pdfFile', 'urlError'], true)
      case JOURNEY_PRINT_FAILED:
         return state.setIn([galleryId, 'pdfFile', 'isPrinting'], false)
                .setIn([galleryId, 'pdfFile', 'printError'], true)
      case RESET_INACTIVITY_TIMER:
         return state.setIn([galleryId, 'inactive', 'lastClick'], moment.now())
                     .setIn([galleryId, 'inactive', 'showIdleWarning'], false)
      case TOGGLE_IDLE_WARNING:
         return state.setIn([galleryId, 'inactive', 'showIdleWarning'], action.payload.toggleState)
      default:
         return state
      }
}


// WEBPACK FOOTER //
// ./src/reducers/journeyState-reducers.js